


















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ConfirmDialog extends Vue {
  @Prop() readonly value!: boolean;
  @Prop({
    default: "Tidak"
  })
  falseText: string;
  @Prop({
    default: "Ya"
  })
  trueText: string;
  @Prop() msg!: string;

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  feedbackTrue() {
    this.dialog = false;
    this.$emit("feedbackTrue");
  }

  feedbackFalse() {
    this.dialog = false;
    this.$emit("feedbackFalse");
  }
}
